import styled from 'styled-components';
import { Card } from 'antd';

export const CardStyle = styled(Card)`
  border-radius: 15px;
`;
